import { NgClass } from "@angular/common";
import {
  Component,
  computed,
  inject,
  input,
  Input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { DefaultProduct } from "../../../shared/pia-api/generated";
import { ProductFamilyFavoritesService } from "../../../shared/services/product-family-favorites.service";
import { ShowOnlyFavoritesService } from "../../../shared/services/show-only-favorites.service";
import { WebStorage } from "../../../shared/services/web-storage";
import { ProductCard } from "../product-card/product-card";

@Component({
  selector: "claas-product-family-products-list",
  imports: [ProductCard, NgClass],
  templateUrl: "./product-family-products-list.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./product-family-products-list.scss",
})
export class ProductFamilyProductsList {
  productsList = input<DefaultProduct[]>([]);

  @Input()
  familyName = "";

  storage = inject(WebStorage);
  productFamilyFavoritesService = inject(ProductFamilyFavoritesService);
  onlyFavoritesStatus = inject(ShowOnlyFavoritesService);
  includedIds = toSignal(this.productFamilyFavoritesService.includedIds$);
  onlyFavoritesIncluded = toSignal(
    this.onlyFavoritesStatus.showOnlyFavoritesStatus$,
  );
  products = computed(() => {
    if (this.onlyFavoritesIncluded() === true) {
      if (this.storage.productFamilyIdsIncluded.length !== 0) {
        return this.productsList().filter((product) => {
          return this.storage.productFamilyIdsIncluded.includes(
            product.ID as string,
          );
        });
      } else {
        return;
      }
    }
    return this.productsList();
  });
}
